import { render, staticRenderFns } from "./maintenance-kind-detail.vue?vue&type=template&id=1af1f712&lang=pug"
import script from "./maintenance-kind-detail.vue?vue&type=script&lang=js"
export * from "./maintenance-kind-detail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports